import { Injectable } from '@angular/core';
import { EventsService } from 'app/main/services/events.service';
import { STORAGE_KEYS, StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class LocalAccountService {

  constructor(
    private storage: StorageService,
    private eventsService: EventsService
  ) { }

  logout(deleteAll = true) {
    // this.eventsService.publishEvent({
    //   event: 'LOGOUT'
    // });
    this.eventsService.publishEvent({
      event: 'CLOSECHAT'
    });
    this.deleteToken();
    this.deleteAccount();
    this.deleteRole();
    this.deleteCompany();
    if (deleteAll) {
      this.storage.remove(STORAGE_KEYS.REDIRECT_URL);
      this.storage.remove(STORAGE_KEYS.REDIRECT_DATA);
    }
  }

  getToken() {
    const token = this.storage.get('TOKEN');
    // if (!token) {
    //   this.eventsService.publishEvent({
    //     event: 'LOGOUT'
    //   });
    // }
    return token;
  }

  setToken(token: string) {
    // if (!token) {
    //   this.eventsService.publishEvent({
    //     event: 'LOGOUT'
    //   });
    // } else {
    //   this.eventsService.publishEvent({
    //     event: 'LOGIN'
    //   });
    // }
    return this.storage.set('TOKEN', token);
  }

  private deleteToken() {
    return this.storage.remove('TOKEN');
  }

  setAccount(body: any) {
    return this.storage.set('ACCOUNT', JSON.stringify(body));
  }

  private deleteAccount() {
    return this.storage.remove('ACCOUNT');
  }

  setRole(body: any) {
    return this.storage.set('ROLE', body);
  }

  private deleteRole() {
    return this.storage.remove('ROLE');
  }

  getRole() {
    return this.storage.get('ROLE');
  }

  isAdmin() {
    return this.getRole() === 'ADMINISTRATOR';
  }

  isOperator() {
    return this.getRole() === 'OPERATOR';
  }

  isStudent() {
    return this.getRole() === 'STUDENT';
  }

  isProfessor() {
    return this.getRole() === 'PROFESSOR';
  }

  isCompany() {
    let company = this.getCompany();
    company = JSON.parse(company);
    const ret = this.isStudent() && company;
    return ret;
  }

  getCompany() {
    return this.storage.get('COMPANY');
  }

  setCompany(body: any) {
    return this.storage.set('COMPANY', body);
  }

  private deleteCompany() {
    return this.storage.remove('COMPANY');
  }

  isBankAdmin() {
    return (this.getRole() === 'BANK_ADMINISTRATOR') || (this.getRole() === 'ADMINISTRATOR');
  }

  isBankAdministrator() {
    return this.getRole() === 'BANK_ADMINISTRATOR';
  }

  async getAccount() {
    let account = '{}';
    if (this.storage.get('ACCOUNT') !== null) {
      account = await this.storage.get('ACCOUNT');
    }
    return await JSON.parse(account);
  }

  async isPolicyAccepted() {
    const account = await this.getAccount();
    return Promise.resolve(account.tacAccepted && account.pacAccepted);
  }
}
